import 'isomorphic-fetch';
import '@fortawesome/fontawesome-free/css/all.css';
import '@elotech/arc/src/assets/less/compiled/protocolo.css';

import './icons/IconsLibrary';

import { ApolloProvider } from '@apollo/client';
import cubejs from '@cubejs-client/core';
import { CubeProvider } from '@cubejs-client/react';
import { NotificationContainer } from '@elotech/components';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { render } from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import App from './app/App.js';
import rootReducer from './app/Reducer.js';
import AuthService from './common/auth/AuthService';
import BootstrapErrorPage from './common/BootstrapErrorPage.react.jsx';
import configureStore from './common/ConfigureStore.js';
import Onboarding from './components/onboarding/Onboarding';
import client from './dashboards/graphql/client';
import ErrorBoundary from './error/ErrorBoundary.js';
import { fetchInitialState } from './FetchInitialState.js';
import { initialState } from './initialState.js';
import keycloakService from './keycloak/KeycloakService';

if (!global.Intl) {
  global.Intl = require('intl');
}

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/dist/locale-data/pt');
  require('@formatjs/intl-pluralrules/dist/locale-data/en');
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/pt');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en');
}

const locale = (navigator.languages && navigator.languages[0]) || 'pt';

const store = configureStore(rootReducer, initialState);

const container = document.getElementById('root');

/* eslint-disable no-console */
fetchInitialState(store)
  .then(config => {
    bootstrapApp(config);
  })
  .catch(err => {
    const message = 'Falha ao carregar o estado inicial da aplicação!';
    console.error(message, err);
    if (err.action) {
      render(<BootstrapErrorPage message={message} error={err} />, container);
    }
  });
/* eslint-enable no-console */

const createCubejsApi = cubejsIp => {
  return cubejs(
    async () => {
      const res = await fetch('/protocolo-api/api/cubejs/auth', {
        headers: {
          Authorization: `Bearer ${
            AuthService.getAuthorizationToken() || keycloakService.getToken()
          }`
        }
      });

      return res.text();
    },
    {
      apiUrl: `${cubejsIp}/cubejs-api/v1`
    }
  );
};

function bootstrapApp(config) {
  const cubejsApi = createCubejsApi(config.cubejsIp);
  const DnDClient = window.innerWidth >= 768 ? HTML5Backend : TouchBackend;

  render(
    <Provider store={store}>
      <ThemeProvider theme={{}}>
        <IntlProvider locale={locale}>
          <Onboarding isCloud={config.isCloud}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
              <ErrorBoundary>
                <CubeProvider cubejsApi={cubejsApi}>
                  <ApolloProvider client={client}>
                    <NotificationContainer>
                      <DndProvider backend={DnDClient}>
                        <App config={config} state={store.getState()} />
                      </DndProvider>
                    </NotificationContainer>
                  </ApolloProvider>
                </CubeProvider>
              </ErrorBoundary>
            </BrowserRouter>
          </Onboarding>
        </IntlProvider>
      </ThemeProvider>
    </Provider>,
    container
  );
}
